/** Row menus cannot render a link, so they open the storefront page from the action instead. */
export function openStorefrontUrl(url: string | null) {
  if (url) window.open(url, '_blank', 'noopener,noreferrer');
}
